<template>
  <div class="userInfo_container" :style="{ height: clientHeight + 'px' }">
    <div class="head_container">
      <div class="head_icon">
        <van-image @click="toCustomerService" class="system" :src="require('../../assets/img/service_icon.png')" width="20px" height="18px"></van-image>
      </div>
    </div>

    <div class="info_bottom_box">
      <div class="info_avatar_box">
        <van-image @click="infoClick" round class="avatar_img" width="64px" height="64px" :src="userInfo.avatar ? userInfo.avatar : require('../../assets/img/notLogin.png')"></van-image>
        <div class="avatar_nickName" @click="infoClick">
          {{ userInfo.nickName }}
        </div>
      </div>
      <div class="info_newsAndLike">
        <div class="info_like" @click="toMyItem('我的收藏')">
          <span class="number">{{ userInfo.likeNum }}</span>
          <span class="text">我的收藏</span>
        </div>
        <!-- <div class="info_news" @click="toMyItem('我的消息')">
          <span class="number">{{userInfo.messageNum}}</span>
          <span class="text">我的消息</span>
        </div> -->
      </div>
      <div class="info_list">
        <div class="info_item" v-for="(item, index) in listData" :key="index" @click="toMyItem(item.text)">
          <div class="item_icon">
            <van-image width="30px" height="30px" :src="item.icon"></van-image>
          </div>
          <div class="item_text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <footer-tab :active="active"></footer-tab>
  </div>
</template>

<script>
import FooterTab from "@/components/FooterTab";
import VueCookie from "vue-cookie";
export default {
  name: "userInfo-container",
  data() {
    return {
      //footer 当前选中下标
      active: 1,
      userInfo: {
        nickName: sessionStorage.getItem("userName") || "登录/注册",
        likeNum: sessionStorage.getItem("likeNum") || 0,
        messageNum: 0,
        avatar: sessionStorage.getItem("userImg") || "",
      },
      listData: [
        // {
        //   icon: require('../../assets/img/order_icon.png'),
        //   text: '我的订单',
        // },
        {
          icon: require("../../assets/img/activity_icon.png"),
          text: "我的活动赛事",
        },
        {
          icon: require("../../assets/img/parking_icon.png"),
          text: "停车缴费",
        },
        {
          icon: require("../../assets/img/help_icon.png"),
          text: "我的求助",
        },
        {
          icon: require("../../assets/img/complaint_icon.png"),
          text: "我的投诉",
        },
        {
          icon: require("../../assets/img/feedback_icon.png"),
          text: "意见反馈",
        },
      ],
      isLogin: false,
    };
  },
  components: {
    FooterTab,
  },
  mounted() {
    setTimeout(() => {
      this.shareInit();
    }, 500);
    let openid = this.$cookie.get("w_open_id");
    let skey = this.$cookie.get("w_skey");
    let uid = this.$cookie.get("w_uid");
    if (openid && skey && uid && uid != 0) {
      this.getUserInfo(uid, openid, skey);
    } else {
      // console.log(this.$route,'route信息');
      // if(uid == 0 && sessionStorage.getItem('againAuth'))
      if (uid == 0 && sessionStorage.getItem("againAuth")) {
        // uid == 0 并且上一级页面来自绑定手机号页 重新授权一次更新cookie
        // sessionStorage.setItem('againAuth','true');
        sessionStorage.removeItem("againAuth");
        this.wxAuth();
      } else {
        if (uid == 0) {
          this.$router.replace({
            name: "bindingPhone",
          });
        } else {
          this.isLogin = false;
        }
      }
    }
  },
  methods: {
    /**
     * 初始化分享事件
     */
    shareInit() {
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        let imgDom = document.createElement("img");
        imgDom.src = require("../../assets/img/share_img.png");
        wx.updateAppMessageShareData({
          title: "天府绿道", // 分享标题
          desc: "个人中心", // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgDom.src, // 分享图标
          success: function() {
            // 分享成功
          },
        });
        wx.updateTimelineShareData({
          title: "天府绿道", // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgDom.src,
          success: function() {
            // 分享成功
          },
        });
      });
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        alert("error: " + res);
      });
    },

    /**
     * 获取用户信息
     * @params skey openid uid
     */
    getUserInfo(uid, openId, skey) {
      console.log("发起请求");
      let data = new FormData();
      data.append("uid", uid);
      data.append("open_id", openId);
      data.append("skey", skey);
      this.$request
        .post(`/appserver/v1/user/get_auth_data`, data)
        .then((res) => {
          if (res.data.ret == 0) {
            localStorage.setItem("uid", res.data.data.uid);
            localStorage.setItem("userName", res.data.data.nickname);
            localStorage.setItem("userImg", res.data.data.head_img_url);
            localStorage.setItem("mobile", res.data.data.mobile);
            sessionStorage.setItem("userName", res.data.data.nickname);
            sessionStorage.setItem("userImg", res.data.data.head_img_url);
            this.userInfo.nickName = res.data.data.nickname;
            this.userInfo.avatar = res.data.data.head_img_url;
            this.isLogin = true;
            this.findMessageCollectNum(res.data.data.uid);
            // 如果手机号为空，跳转绑定手机号页面
            if (!res.data.data.mobile) {
              this.$router.replace({
                name: "bindingPhone",
              });
            }
          } else if (res.data.ret == 1) {
            // 登录过期
            if (res.data.errorcode == 20002) {
              localStorage.removeItem("uid");
              localStorage.removeItem("userName");
              localStorage.removeItem("userImg");
              localStorage.removeItem("mobile");
              sessionStorage.removeItem("userName");
              sessionStorage.removeItem("userImg");
              this.isLogin = false;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    /**
     * 根据uid获取用户消息和收藏总数
     */
    findMessageCollectNum(uid) {
      let data = new FormData();
      data.append("jsonCollectBean", { type: "" });
      data.append("uid", uid);
      this.$request
        .post(`/appserver/v1/message/findMessageCollectNum`, data)
        .then((res) => {
          console.log(res.data);
          if (res.data.ret == 0) {
            this.userInfo.likeNum = res.data.data.collectNum;
            this.userInfo.messageNum = res.data.data.messageNum;
            sessionStorage.setItem("likeNum", res.data.data.collectNum);
          } else {
            sessionStorage.removeItem("likeNum");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    /**
     * 登录
     */
    infoClick() {
      if (this.isLogin) {
        return;
        // this.$router.push({
        //   name: 'userInfoDetail',
        //   query: {
        //     avatar: this.userInfo.avatar,
        //     nickName: this.userInfo.nickName
        //   }
        // })
      } else {
        // 未登录
        this.wxAuth();
      }
    },

    /**
     * 跳转智能客服
     */
    toCustomerService() {
      this.$router.push({
        path: "/customerService",
        query: {
          isLogin: this.isLogin ? 1 : 0, // 1已登录 0 未登录
        },
      });
    },
    /**
     * 跳转我的。。。
     */
    toMyItem(text) {
      if (!this.isLogin) {
        // this.$toast('请登录~');
        this.wxAuth();
        return;
      }
      if (text === "我的活动赛事") {
        this.$router.push({
          path: "/myActivityList",
        });
      } else if (text === "我的求助") {
        this.$router.push({
          path: "/myHelp",
        });
      } else if (text === "我的投诉") {
        this.$router.push({
          path: "/myComplain",
        });
      } else if (text === "我的收藏") {
        this.$router.push({
          path: "/myCollect",
        });
      } else if (text === "我的消息") {
        this.$router.push({
          path: "/myMessage",
        });
      } else if (text === "意见反馈") {
        this.$router.push({
          path: "/feedback",
        });
      } else if (text === "停车缴费") {
        this.$router.push({
          path: "/carParkList",
        });
      }
    },
  },
  computed: {
    clientHeight() {
      return document.body.clientHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.userInfo_container {
  background: #f2f2f2;
  .head_container {
    width: 100%;
    position: relative;
    background: url("../../assets/img/userInfo_bg.png") no-repeat;
    background-size: 100% 100%;
    min-height: 150px;
    .head_icon {
      position: absolute;
      display: flex;
      right: 0;
      top: 10px;
      align-items: center;
      .system {
        margin: 0 20px;
      }
    }
  }
  .info_bottom_box {
    width: 100%;
    min-height: 200px;
    background: white;
    border-radius: 8px 8px 0 0;
    transform: translateY(-20px);
    position: relative;
    padding: 0 20px;
    padding-top: 50px;
    box-sizing: border-box;

    .info_avatar_box {
      .avatar_img {
        position: absolute;
        top: 0;
        left: 20px;
        transform: translateY(-50%);
        border: 3px solid white;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      }
      .avatar_nickName {
        font-size: 18px;
        color: #000;
        font-weight: 600;
      }
    }
    .info_newsAndLike {
      margin-top: 40px;
      display: flex;
      .info_like {
        margin-right: 25px;
      }
      .info_news,
      .info_like {
        .number {
          font-size: 22px;
          color: #000;
          margin-right: 5px;
        }
        .text {
          color: #000;
          opacity: 0.5;
          font-size: 12px;
        }
      }
    }
    .info_list {
      border-top: 1px solid #f5f5f5;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-self: baseline;
      clear: both;
      .info_item {
        width: 33.3333%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: white;
        height: 100px;
        .item_text {
          margin-top: 8px;
          color: black;
          opacity: 0.85;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
